// AssessmentTypeTable.js
import { useState, useEffect } from 'react';
import api from '../../../services/api';

const AssessmentTypeTable = ({assessments, fieldOptions }) => {
  // Создаем маппинг option_value -> массив оценок
  const assessmentsByType = {};

  // Инициализируем маппинг для каждого option_value
  fieldOptions.forEach(option => {
    assessmentsByType[option.option_value] = [];
  });

  // Распределяем оценки по типам
  assessments.forEach(assessment => {
    const assessmentType = assessment.assessment_type;
    if (assessmentType && assessmentsByType[assessmentType]) {
      assessmentsByType[assessmentType].push(assessment);
    }
  });
  // Формируем статистику из маппинга
  const stats = Object.entries(assessmentsByType).map(([optionValue, assessmentsList]) => {
    // Находим соответствующий option_text
    const option = fieldOptions.find(opt => opt.option_value === optionValue);
    const reportType = option ? option.option_text : optionValue;
    
    const totalCount = assessmentsList.length;
    
    // Считаем количество критериев с score = 0
    const zeroScoreCount = assessmentsList.reduce((count, assessment) => {
      if (assessment.items && Array.isArray(assessment.items)) {
        return count + assessment.items.filter(item => item.score === 0).length;
      }
      return count;
    }, 0);
    
    const percentage = totalCount > 0 ? ((zeroScoreCount / totalCount) * 100).toFixed(1) : '0.0';
    
    return {
      reportType,
      totalCount,
      zeroScoreCount,
      percentage
    };
  });

  // Добавляем "Без типа" если есть оценки без типа
  const assessmentsWithoutType = assessments.filter(a => !a.assessment_type);
  if (assessmentsWithoutType.length > 0) {
    const zeroScoreCount = assessmentsWithoutType.reduce((count, assessment) => {
      if (assessment.items && Array.isArray(assessment.items)) {
        return count + assessment.items.filter(item => item.score === 0).length;
      }
      return count;
    }, 0);
    
    const percentage = assessmentsWithoutType.length > 0 ? 
      ((zeroScoreCount / assessmentsWithoutType.length) * 100).toFixed(1) : '0.0';
    
    stats.push({
      reportType: 'Без типа',
      totalCount: assessmentsWithoutType.length,
      zeroScoreCount,
      percentage
    });
  }

  // Сортируем по общему количеству (по убыванию)
  const sortedStats = stats.sort((a, b) => b.totalCount - a.totalCount);
    // Убираем проверку loading, так как мы получаем assessments из props
  // и можем отображать таблицу сразу
  

  // Убираем проверку error, так как мы не делаем API-запросы в этом компоненте
  // и получаем все данные через props
  

  return (
    <div className="table-wrapper">
      <h3>Статистика по типам оценок</h3>
      <table className="stats-table">
        <thead>
        <tr>
          <th>Тип обращения</th>
          <th>Количество проверок</th>
          <th>Количество ошибок</th>
          <th>% ошибок</th>
        </tr>
        </thead>
        <tbody>
        {sortedStats.map((stat) => (
            <tr key={stat.reportType}>
              <td>{stat.reportType}</td>
              <td>{stat.totalCount}</td>
              <td>{stat.zeroScoreCount}</td>
              <td>{stat.percentage}%</td>
            </tr>
        ))}
        {sortedStats.length === 0 && (
            <tr>
              <td colSpan="4" style={{textAlign: 'center'}}>Нет данных для отображения</td>
            </tr>
        )}
        </tbody>
        <tfoot>
          <tr style={{backgroundColor: '#f5f5f5', fontWeight: 'bold'}}>
            <td>Grand Total</td>
            <td>{sortedStats.reduce((sum, stat) => sum + stat.totalCount, 0)}</td>
            <td>{sortedStats.reduce((sum, stat) => sum + stat.zeroScoreCount, 0)}</td>
            <td>{
              sortedStats.length > 0
                  ? ((sortedStats.reduce((sum, stat) => sum + stat.zeroScoreCount, 0) / sortedStats.reduce((sum, stat) => sum + stat.totalCount, 0)) * 100).toFixed(1)
                  : '0.0'
            }%
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default AssessmentTypeTable;